import axios from 'axios';

//const API_BASE_URL = "https://vcard.apanel.leewaysofttech.com/DEPRESSION_DIARIES_APIS";

const API_BASE_URL = "https://drmanishbansal.org/DEPRESSION_DIARIES_APIS";


export const sendOtp = (mobile) =>
    axios.post(`${API_BASE_URL}/auth.php?action=send_otp`, { mobile });

export const verifyOtp = (mobile, otp) =>
    axios.post(`${API_BASE_URL}/auth.php?action=verify_otp`, { mobile, otp });

export const adminLogin = (username, mobile) =>
    axios.post(`${API_BASE_URL}/auth.php?action=admin_login`, { username, mobile });

export const registerUser = (userData) =>
    axios.post(`${API_BASE_URL}/auth.php?action=register`, userData);

export const createRazorpayOrder = (amount) =>
    axios.post(`${API_BASE_URL}/orders.php?action=create_razorpay_order`, { amount });

export const verifyAndPlaceOrder = (paymentData) =>
    axios.post(`${API_BASE_URL}/orders.php?action=verify_and_place`, paymentData);

export const fetchOrders = (userId, role) =>
    axios.get(`${API_BASE_URL}/orders.php?action=get_orders&user_id=${userId}&role=${role}`);